<app-mobile-header [title]="'i18n.domain.fast-checkin.title'"></app-mobile-header>
@if(showError) {
  <div class="row">
    <div class="col-lg-4 offset-lg-4 col-md-6 offset-md-3 mt-5">
      <div class="alert alert-danger text-center" role="alert">
        {{ errorMessage | translate }}
      </div>
    </div>
  </div>
} @else {
  <div class="row">
    <div class="col-lg-4 offset-lg-4 col-md-6 offset-md-3 mt-4">
      <ejs-stepper stepType="Default" [activeStep]="stepIndex" [readOnly]="true">
        <e-steps>
          <e-step></e-step>
          <e-step></e-step>
        </e-steps>
      </ejs-stepper>
    </div>
  </div>
  <div class="row">
    <div class="col-lg-4 offset-lg-4 col-md-6 offset-md-3">
      @switch (stepIndex) {
        @case (0) {
          <app-fast-checkin-step-user-info [zoneName]="zoneName" [userInfoForm]="userInfoForm" [fastCheckinType]="fastCheckinType" (next)="onUserInfoNext($event)"></app-fast-checkin-step-user-info>
        }
        @case (1) {
          <app-fast-checkin-step-duration [zoneInfo]="zoneInfo" [controlPlate]="controlPlate" (submit)="onDurationSubmit($event)" (back)="onBack()"></app-fast-checkin-step-duration>
        }
      }
    </div>
  </div>
}
